/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

const SkeletonDiv = ({ className = "", text = "", as = "div" }) => {
  const Tag = as;
  return (
    <Tag
      className={cn(
        "min-h-12 w-full bg-secondary flex items-center justify-center animate-pulse",
        className,
      )}
      test-id="hjTFnGHm"
    >
      {text && (
        <p className="text-sm font-medium text-white" test-id="yLkgCPwh">
          {text}
        </p>
      )}
    </Tag>
  );
};

export default SkeletonDiv;
